<template>
    <EditBase
        v-if="event.provider ? event.provider.includes('survey') : false"
        :show-edit="showEdit"
        :question="question"
        :qNum="qNum"
        :event="event"
        :patient="patient"
        :survey="survey"
        :saving-edit="savingEdit"
        :save-disabled="!enableSave"
        :show-remove-response="showRmvResp"
        :is-mandatory="checkIfMandatory()"
        @response-removed="removeResponse()"
        @save-edit="updateQuestion"
        @open-dialog="showEdit = true"
        @close-dialog="closePopup()">
        <div class="date inl">
            {{ qDate }}
        </div>
        <div class="inl">
            <el-date-picker
                v-model="updateResponse"
                @change="onResponseChange()"
                :picker-options="pickerOptions"
                :clearable="!checkIfMandatory()"
                :type="questionConfig.type"
                :format="questionConfig.format"
                :placeholder="`Pick a ${questionConfig.type}`">
            </el-date-picker>
        </div>
    </EditBase>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EditBase from './EditBase'
import QuestionEdit from './'
import { v4 as uuidv4 } from 'uuid'

export default {
    name: 'edit-date',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: this.getQuestionResponse(),
            enableSave: false,
            showRmvResp: !this.checkIfMandatory() && this.response,
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey'
        ]),
        closePopup() {
            this.showEdit = false
            this.enableSave = false
            this.updateResponse = this.getQuestionResponse()
            this.showRmvResp = !this.checkIfMandatory() && this.response
        },
        removeResponse() {
            this.updateResponse = ''
            this.showRmvResp = false
            this.enableSave = this.checkIfMandatory() ? false : true
        },
        onResponseChange() {
            if(this.updateResponse &&
                (this.updateResponse != null || this.updateResponse != "")) {
                    this.enableSave = true
                    this.showRmvResp = this.checkIfMandatory() ? false : true
            } else {
                this.enableSave = this.checkIfMandatory() ? false : true
                this.showRmvResp = false
            }
        },
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate()
            else
                update.push(this.getQuestionUpdate())
            
            console.log(update)

            //return
            this.savingEdit = true

            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false
                    this.enableSave = false
                    this.showEdit = false
                    this.showRmvResp = !this.checkIfMandatory() && this.response
                })
        },
        getQuestionResponse() {
            if(this.response && Array.isArray(this.response) && this.response.length > 0)
                return new Date(this.response[0].year, this.response[0].month - 1, this.response[0].date || 1)
            return ''
        },
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: null
            }
            if(this.updateResponse instanceof Date) {
                let answer = {
                    month: this.updateResponse.getMonth() + 1,
                    year: this.updateResponse.getFullYear()
                }
                if(this.questionConfig.type === 'date')
                    answer.date = this.updateResponse.getDate()
                if(this.questionResponseId())
                    answer.id = this.questionResponseId()
                else
                    answer.id = uuidv4()
                update.answer = [answer]
            }
            return update
        },
        questionResponseId() {
            if(this.response && Array.isArray(this.response) && this.response.length > 0)
                return this.response[0].id
            return false
        }
    },

    computed: {
        questionConfig() {
            return this.question.prompt.includes('date') ? 
                ({
                    type: 'date',
                    format: 'MMM d, yyyy'
                }) : 
                ({
                    type: 'month',
                    format: 'MMM, yyyy'
                })
        },

        pickerOptions() {
            return this.checkIfDisalFutDates() ? {
                    disabledDate(date) {
                        return date > Date.now();
                }
            } : {}
        }
    },

    components: {
        EditBase
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';

.el-date-editor.el-input {
    margin-left: 10px;
}
</style>
